// cestina pro vsechna formatovani pres dayjs (nazvy dnu a mesicu) - importuje se jako prvni ve vstupnich souborech
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/cs";

// mesic za cislem dne je ve 2. pade (12. rijna), samostatne v 1. pade (rijen)
const MONTHS_GENITIVE = "ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince".split("_");
const MONTHS_NOMINATIVE = "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_");
const DAY_MONTH_FORMAT = /D\.?\s*MMMM/u;

function months(date: dayjs.Dayjs, format: string) {
	return DAY_MONTH_FORMAT.test(format)
		? MONTHS_GENITIVE[date.month()]
		: MONTHS_NOMINATIVE[date.month()];
}

months.f = MONTHS_GENITIVE;
months.s = MONTHS_NOMINATIVE;

dayjs.extend(updateLocale);
dayjs.updateLocale("cs", {
	months,
});
dayjs.locale("cs");
